export const changeWrapperRowZIndex = (
  wrapper: HTMLElement | null,
  increaseSize: number,
  isWrapperRow = false,
  selector = '.row-container',
  fixedZindex?: boolean
): HTMLElement | null => {
  const wrapperElement = isWrapperRow
    ? wrapper
    : (wrapper?.closest(selector) as HTMLElement);

  if (!wrapperElement) {
    return null;
  }

  if (fixedZindex) {
    wrapperElement.style.zIndex = '3';
  }

  let wrapperZIndex = +window
    .getComputedStyle(wrapperElement, '')
    .getPropertyValue('z-index');

  if (wrapperZIndex) {
    wrapperZIndex += increaseSize;

    wrapperElement.style.zIndex = wrapperZIndex.toString();
  }

  return wrapperElement;
};
